
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import useLocale from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import AuthModal from '@/components/AuthModal';
import NarrowDashboardLayout from '@/components/layout/NarrowDashboardLayout';
import Seo from '@/components/Seo';
import { useUser } from '@/utils/useUser';
function LoadingScreen() {
    return (<div className='flex min-h-screen items-center justify-center bg-ve-bg'>
      <span className='h-7 w-7 animate-spin rounded-full border-2 border-white/10 border-t-indigo-400'/>
    </div>);
}
const ProjectList = dynamic(() => import('@/components/video-editor/VideoEditor').then((mod) => mod.ProjectList), { ssr: false, loading: LoadingScreen });
const VideoEditor = dynamic(() => import('@/components/video-editor/VideoEditor'), { ssr: false, loading: LoadingScreen });
function SampleProjectEditor() {
    const { t } = useLocale('common');
    const [sampleId, setSampleId] = useState<string | null>(null);
    const [showAuth, setShowAuth] = useState(false);
    useEffect(() => {
        let cancelled = false;
        let undoSample: (() => void) | null = null;
        (async () => {
            const [{ cloneSampleTemplate }, { useVideoEditorStore }] = await Promise.all([
                import('@/components/video-editor/templates/sample-video-ad'),
                import('@/components/video-editor/store'),
            ]);
            // The editor store is shared with the signed-in editor. If this
            // component has already been swapped out (a session resolved), writing
            // the read-only sample now would open the user's own projects as
            // "View Only".
            if (cancelled)
                return;
            const { project, tracks, keyFrames, mediaItems } = cloneSampleTemplate();
            const store = useVideoEditorStore.getState();
            store.resetEditorUi();
            store.setProject(project);
            store.setTracks(tracks);
            store.setKeyFrames(keyFrames);
            store.setMediaItems(mediaItems);
            store.setIsReadOnly(true);
            undoSample = () => {
                const current = useVideoEditorStore.getState();
                // Leave the store alone if another project has been loaded since.
                if (current.project?.id !== project.id)
                    return;
                current.setIsReadOnly(false);
                current.setProject(null);
                current.setTracks([]);
                current.setKeyFrames([]);
                current.setMediaItems([]);
            };
            setSampleId(project.id);
        })();
        return () => {
            cancelled = true;
            undoSample?.();
        };
    }, []);
    if (!sampleId)
        return <LoadingScreen />;
    return (<>
      <VideoEditor projectId={sampleId} headerAction={<button type='button' onClick={() => setShowAuth(true)} className='inline-flex h-9 shrink-0 items-center rounded-lg bg-indigo-500 px-3.5 text-[13px] font-semibold text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.18)] transition-colors hover:bg-indigo-400'>
            {t('Sign up')}
          </button>}/>
      <AuthModal showModal={showAuth} onClose={() => setShowAuth(false)} redirectTo='/ai-video-editor'/>
    </>);
}
const AIVideoEditorPage = () => {
    const { t } = useLocale('common');
    const { user, isLoading } = useUser();
    return (<NarrowDashboardLayout showMobileMenu={!!user} sidebarVisible={!!user} mobileMenuTone='dark'>
      <main className={user
            ? 'flex-1 overflow-y-auto bg-ve-bg focus:outline-none'
            : 'flex-1 overflow-hidden bg-ve-bg focus:outline-none'}>
        <Seo templateTitle={t('AI Video Editor')} description={t('Create professional videos with AI-generated content - video, images, music, voiceovers, and sound effects')}/>
        {/* Wait for the session before mounting the signed-out sample: it
            writes read-only state into the editor store that the user's own
            projects open with. */}
        {user ? (<ProjectList />) : isLoading ? (<LoadingScreen />) : (<SampleProjectEditor />)}
      </main>
    </NarrowDashboardLayout>);
};
export default AIVideoEditorPage;

    async function __Next_Translate__getStaticProps__1a13a29a10b__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-video-editor/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13a29a10b__ as getStaticProps }
  